import { createReducer, on } from '@ngrx/store';
import { QuoteState } from '../../models/quote.model';
import * as QuoteActions from './quote.actions';

export const initialQuoteState: QuoteState = {
  applications: [],
  currentApplication: null,
  loading: false,
  submitting: false,
  error: null,
  success: false,
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0
};

export const quoteReducer = createReducer(
  initialQuoteState,
  on(QuoteActions.submitQuoteApplication, state => ({
    ...state,
    submitting: true,
    error: null,
    success: false
  })),
  on(QuoteActions.submitQuoteApplicationSuccess, (state, { application }) => ({
    ...state,
    submitting: false,
    currentApplication: application,
    success: true,
    error: null
  })),
  on(QuoteActions.submitQuoteApplicationFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    success: false,
    error
  })),
  on(QuoteActions.getQuoteApplications, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(QuoteActions.getQuoteApplicationsSuccess, (state, { page }) => ({
    ...state,
    loading: false,
    applications: page.result,
    pageNumber: page.pageNumber,
    pageSize: page.pageSize,
    totalRecords: page.totalRecords,
    error: null
  })),
  on(QuoteActions.getQuoteApplicationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(QuoteActions.getQuoteApplicationById, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(QuoteActions.getQuoteApplicationByIdSuccess, (state, { application }) => ({
    ...state,
    loading: false,
    currentApplication: application,
    error: null
  })),
  on(QuoteActions.getQuoteApplicationByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(QuoteActions.resetQuoteState, () => initialQuoteState)
);